export default __webpack_public_path__ + "static/media/new_slide.613cdcb8.svg";